var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.571,1.928a11,11,0,1,0,11,11,11,11,0,0,0-11-11Zm0,20.625a9.593,9.593,0,0,1-3.808-.783l5.009-5.635a.688.688,0,0,0,.174-.457V13.616a.687.687,0,0,0-.687-.687c-2.428,0-4.989-2.524-5.014-2.549a.687.687,0,0,0-.486-.2H6.008a.688.688,0,0,0-.687.688v4.125a.687.687,0,0,0,.38.615l2.37,1.185v4.037A9.631,9.631,0,0,1,4.872,8.8H7.383a.688.688,0,0,0,.486-.2l2.75-2.75a.688.688,0,0,0,.2-.486V3.7a9.652,9.652,0,0,1,6.967.572c-.089.075-.176.154-.259.237a4.126,4.126,0,0,0,2.914,7.042q.1,0,.2-.005a16.145,16.145,0,0,1-.181,8,.685.685,0,0,0-.018.112,9.6,9.6,0,0,1-6.878,2.893Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorld);
export default __webpack_public_path__ + "static/media/icon-world.31c28362e87cdb2f0f9ab0af901c318a.svg";
export { ForwardRef as ReactComponent };